import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default class BinaryField extends Component {
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      schema
    } = this.props;
    return /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      fontStyle: "italic",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.params.errors.fileType.${schema.format}`
      })
    });
  }
}